import React from "react";
import { CgChevronDown, CgChevronLeft } from "react-icons/cg";
import productsData from "../data/products";
import blogThreeData from "../services6/blogThreeData";

/* 🔹 Helper: Format category */
const formatCategory = (str) =>
  str.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

/* =========================
   🔥 PRODUCTS (Dynamic)
========================= */
const categoryMap = new Map();

for (const item of productsData) {
  if (!categoryMap.has(item.category)) {
    categoryMap.set(item.category, []);
  }
  categoryMap.get(item.category).push(item);
}

const productMenu = Array.from(categoryMap.entries()).map(
  ([category, items]) => ({
    title: formatCategory(category),
    path: `/products/${category}`,
    iconClosed: <CgChevronLeft />,
    iconOpened: <CgChevronDown />,

    subNav: items.map((product) => ({
      title: product.title,
      path: `/products/${category}/${product.slug}`,
    })),
  })
);

/* =========================
   🔥 SERVICES (Dynamic)
========================= */
const servicesMenu = blogThreeData.map((service) => ({
  title: service.title,
  path: `/services/${service.slug}`,
}));

/* =========================
   ✅ FINAL MENU
========================= */
const menuData = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About",
    path: "/about",
  },

  /* 🔥 SERVICES DROPDOWN */
  {
    title: "Services",
    path: "/services",
    iconClosed: <CgChevronLeft style={{ rotate: "-180deg"}} />,
    iconOpened: <CgChevronDown />,
    subNav: servicesMenu,
  },

  /* 🔥 PRODUCTS DROPDOWN */
  {
    title: "Products",
    path: "/products",
    iconClosed: <CgChevronLeft style={{ rotate: "-180deg"}} />,
    iconOpened: <CgChevronDown />,
    subNav: productMenu,
  },
];

export default menuData;